import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ClipboardList, ArrowRight, X } from "lucide-react";

const PatientsZoneBanner = () => {
  const [hidden, setHidden] = useState(false);
  if (hidden) return null;

  return (
    <section
      className="px-6 py-5 md:py-6 relative"
      style={{
        background: "linear-gradient(135deg, var(--sage-600) 0%, var(--sage-700) 100%)",
        color: "var(--cream)",
        borderBottom: "1px solid var(--sage-100)",
      }}
      data-testid="patients-zone-top"
    >
      {/* Decoración estrella */}
      <div className="absolute top-2 right-16 font-display text-3xl opacity-20 hidden md:block" style={{ color: "var(--sage-200)" }}>✦</div>
      <div className="absolute bottom-2 left-20 font-display text-2xl opacity-15 hidden md:block" style={{ color: "var(--sage-200)" }}>✧</div>

      <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-between gap-4 relative">
        <div className="flex items-center gap-4 flex-1 min-w-0">
          <div
            className="h-12 w-12 md:h-14 md:w-14 rounded-full flex items-center justify-center shrink-0"
            style={{ background: "rgba(250,247,238,0.15)", border: "1px solid rgba(250,247,238,0.2)" }}
          >
            <ClipboardList size={22} />
          </div>
          <div className="font-sans-body min-w-0">
            <div className="text-[11px] md:text-xs uppercase tracking-widest mb-1" style={{ color: "var(--sage-200)" }}>
              Zona pacientes
            </div>
            <div className="font-display text-base md:text-xl leading-tight" style={{ color: "var(--cream)" }}>
              ¿Tienes cita? Rellena tu{" "}
              <span className="handwritten" style={{ color: "var(--sage-200)" }}>
                cuestionario previo
              </span>
            </div>
            <div className="text-[11px] md:text-xs mt-1 opacity-75 hidden md:block">
              Accede sólo si tu optometrista te lo ha indicado — es privado y confidencial
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Link
            to="/cuestionarios"
            className="inline-flex items-center gap-2 rounded-full px-4 md:px-6 py-2.5 font-sans-body text-sm font-semibold transition-transform hover:scale-105 whitespace-nowrap"
            style={{ background: "var(--cream)", color: "var(--sage-700)" }}
            data-testid="patients-zone-top-cta"
          >
            Acceder <ArrowRight size={14} />
          </Link>
          <button
            onClick={() => setHidden(true)}
            aria-label="Cerrar aviso"
            className="h-8 w-8 rounded-full flex items-center justify-center opacity-70 hover:opacity-100 transition-opacity"
            style={{ background: "rgba(250,247,238,0.1)" }}
            data-testid="patients-zone-top-close"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default PatientsZoneBanner;
